import type { Command } from "./command.types";
import type { SavedFile } from "./files.types";

export type Ticket = {
	id?: number;
	createdAt: Date;
	updatedAt: Date;
	closedAt: Date;
	ticketLabelId: string;
	ticketLabel: TicketLabel;
	commandId?: string | number;
	command?: Command;
	priority: TicketPriority;
	description: string;
	files: File[] | SavedFile[];
	ownerId?: number;
	openById?: number;
	status: TicketStatus;
	discount?: number | null;
};

export enum TicketPriority {
	LOW = "LOW",
	MEDIUM = "MEDIUM",
	HIGH = "HIGH",
}

export enum TicketScope {
	SUP = "SUP",
	CLIENTS = "CLIENTS",
	ALL = "ALL",
}

export enum TicketStatus {
	NEW = "NEW",
	OPEN = "OPEN",
	BLOCKED = "BLOCKED",
	CLOSED = "CLOSED",
}

export type TicketLabel = {
	id: number;
	label: string;
	proof: boolean;
	scope: TicketScope;
	priority: TicketPriority;
	published: boolean;
};

export type TicketLog = {
	id: number;
	createdAt: Date;
	updatedAt: Date;
	type: string;
	meta: object;
};

export type TicketLogChangeStatusMeta = {
	from: TicketStatus;
	to: TicketStatus;
	discount?: number | null;
};
